/**
 * 添加标签组件
 */
angular.module('addTagsModule', []).directive('addTags', [
    '$timeout',
    '$validation',
    function($timeout, $validation) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                getData: '=',
                tags: '=',
            },
            templateUrl: './editingCenter/app/directive/addTags/addTags_tpl.html',
            link: function(scope, $element, $attrs) {
                let promise;
                initStatus();
                initData();
                /**
                 * [deleteTag description] 删除标签
                 * @return {[type]} [description]
                 */
                scope.deleteTag = function(index) {
                    scope.tags.splice(index, 1);
                };
                /**
                 * [getDataToPush description] 获取数据并且填充
                 * @return {[type]} [description]
                 */
                function getDataToPush() {
                    if (!scope.status.tagInput) {
                        scope.status.showButton = true;
                        return;
                    }
                    if (scope.existsList()) {
                        return;
                    }
                    $validation.validate(scope.tagsForm).success(() => {
                        if (promise) {
                            $timeout.cancel(promise);
                            promise = null;
                        }
                        promise = $timeout(() => {
                            if (!scope.getData || typeof scope.getData.fn != 'function') {
                                return;
                            }
                            scope.getData.fn(scope.status.tagInput).then((resp) => {
                                if (
                                    !angular.isObject(resp) ||
                                    !angular.isObject(resp.DATA) ||
                                    !angular.isArray(resp.DATA.absent_list) ||
                                    resp.DATA.absent_list.length > 0
                                ) {
                                    scope.status.exists = false;
                                    return;
                                }
                                scope.tags = angular.isArray(scope.tags) ? scope.tags : [];
                                scope.tags.push(scope.status.tagInput);
                                scope.status.tagInput = '';
                                $element.find('input')[0].focus();
                            });
                        }, 800);
                    });
                }
                /**
                 * [existsList description] 用户是否存在列表中
                 * @return {[type]} [description]
                 */
                scope.existsList = function() {
                    if (!angular.isArray(scope.tags)) return false;
                    return scope.tags.indexOf(scope.status.tagInput) >= 0;
                };
                /**
                 * [clickButton description] 点击添加按钮
                 */
                scope.clickButton = function() {
                    scope.status.showButton = false;
                    $timeout(() => {
                        $element.find('input')[0].focus();
                    });
                };
                /**
                 * [blur description] 失焦方法
                 * @return {[type]} [description]
                 */
                scope.blur = function() {
                    getDataToPush();
                };
                /**
                 * [inputFinish description] 输入完成
                 * @return {[type]} [description]
                 */
                scope.inputFinish = function($event) {
                    scope.status.exists = true;
                    if ($event.keyCode !== 13) return;
                    getDataToPush();
                };
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        showButton: true,
                        exists: true,
                    };
                    scope.data = {};
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {}
            },
        };
    },
]);
